import React from 'react';
import jwt from 'jsonwebtoken';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';

import { getValue } from '../helpers';
import API from '../../services/api';
import CustomInputMoney from '../custom/inputmoney';

export default function DialogTransferencia({ children, ...props }) {
  const decoded = jwt.decode(sessionStorage.getItem('token'));
  const { open, setOpen } = props;
  const [value, setValue] = React.useState('');
  const [description, setDescription] = React.useState('Transferência');
  const [toAccount, setToAccount] = React.useState('');

  function handleConfirm(event) {
    event.preventDefault();
    API.Transferencias.store({
      owners_id: decoded.uid,
      from_account_id: getValue(props.item, 'id'),
      to_account_id: toAccount,
      description: description,
      valor: value,
    })
      .then(props.onSuccess || onSuccess)
      .catch(props.onFailure || onFailure);
    if (props.onConfirm) {
      props.onConfirm();
    }
    if (setOpen) {
      setOpen(false);
    }
  }

  function onSuccess(response) {
    if (props.setReload) {
      props.setReload(true);
    }
  }

  function onFailure(error) {
    console.log(error.message);
    if (props.setReload) {
      props.setReload(true);
    }
  }

  function handleCancel(event) {
    event.preventDefault();
    if (setOpen) {
      setOpen(false);
    }
    if (props.onCancel) {
      props.onCancel();
    }
  }

  function handleToAccountChange(event) {
    event.preventDefault();
    setToAccount(event.target.value);
  }

  return (
    <Dialog open={open} fullWidth={true} maxWidth={'sm'} onClose={handleCancel} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">{'Transferência'}</DialogTitle>
      <DialogContent>
        <DialogContentText>{'Conta de origem: ' + getValue(props.item, 'user.name', '')}</DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="description"
          label="Descrição da transferência"
          type="text"
          value={description}
          fullWidth={true}
          onChange={(e) => {
            setDescription(e.target.value);
          }}
        />
        <TextField autoFocus margin="dense" id="valor" label="Conta destino" type="text" value={toAccount} fullWidth={true} onChange={handleToAccountChange} />
        <CustomInputMoney autoFocus={true} label="Valor da transferência" setValue={setValue} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          {'Cancelar'}
        </Button>
        <Button onClick={handleConfirm} color="primary">
          {'Confirmar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
